import heroBg from '../assets/images/hero-bg.jpg';
import nasiGoreng from '../assets/images/nasi-goreng.jpg';
import chickenTeriyaki from '../assets/images/chicken-teriyaki.jpg';
import chickenKatsu from '../assets/images/chicken-katsu.jpg';
import spaghetti from '../assets/images/spaghetti.jpg';
import mieAyam from '../assets/images/mie-ayam.jpg';
import kwetiau from '../assets/images/kwetiau.jpg';
import springRolls from '../assets/images/spring-rolls.jpg';
import frenchFries from '../assets/images/french-fries.jpg';
import bakso from '../assets/images/bakso.jpg';

export interface MenuItem {
  id: string;
  name: string;
  price: string;
  image: string;
  category: string;
  description?: string;
}

export const categories = [
  "Main Course",
  "Menu Mie",
  "Menu Kwetiau",
  "Snack & Sampingan",
  "Express Bowl"
];

export const menuItems: MenuItem[] = [
  // Main Course
  {
    id: "1",
    name: "Nasi Crispy Chicken Spicy Mayo",
    price: "Rp32.000",
    image: chickenKatsu,
    category: "Main Course",
    description: "Nasi dengan ayam crispy disiram saus spicy mayo yang pedas gurih."
  },
  {
    id: "2",
    name: "Nasi Ayam Crispy Black Pepper Sauce",
    price: "Rp32.000",
    image: chickenKatsu,
    category: "Main Course",
    description: "Nasi dengan ayam crispy dan saus lada hitam yang nendang."
  },
  {
    id: "3",
    name: "Spaghetti Bolognaise",
    price: "Rp26.000",
    image: spaghetti,
    category: "Main Course",
    description: "Pasta spaghetti dengan saus daging cincang tomat klasik."
  },
  {
    id: "4",
    name: "Nasi & Ayam Teriyaki",
    price: "Rp40.000",
    image: chickenTeriyaki,
    category: "Main Course",
    description: "Nasi putih disajikan dengan ayam masak saus teriyaki manis gurih."
  },
  {
    id: "5",
    name: "Nasi & Ayam Katsu Teriyaki",
    price: "Rp41.000",
    image: chickenKatsu,
    category: "Main Course",
    description: "Perpaduan ayam katsu renyah dengan saus teriyaki."
  },
  {
    id: "6",
    name: "Mie Ayam Teriyaki",
    price: "Rp40.000",
    image: mieAyam,
    category: "Main Course",
    description: "Mie kenyal dengan topping ayam teriyaki."
  },
  {
    id: "7",
    name: "Nasi & Ayam Lada Hitam",
    price: "Rp40.000",
    image: chickenTeriyaki,
    category: "Main Course",
    description: "Ayam dimasak dengan bumbu lada hitam spesial."
  },
  {
    id: "8",
    name: "Nasi & Sapo Tahu Ayam",
    price: "Rp44.000",
    image: nasiGoreng, // Placeholder for Sapo Tahu
    category: "Main Course",
    description: "Sapo tahu lembut dengan potongan ayam dan sayuran."
  },
  {
    id: "9",
    name: "Nasi & Sapo Tahu Sapi",
    price: "Rp46.000",
    image: nasiGoreng,
    category: "Main Course"
  },
  {
    id: "10",
    name: "Nasi & Sapo Tahu Seafood",
    price: "Rp48.000",
    image: nasiGoreng,
    category: "Main Course"
  },
  {
    id: "11",
    name: "Nasi & Chicken Bulgogi",
    price: "Rp39.000",
    image: chickenTeriyaki,
    category: "Main Course"
  },
  {
    id: "12",
    name: "Fish & Chips",
    price: "Rp59.000",
    image: frenchFries,
    category: "Main Course",
    description: "Ikan dori goreng tepung disajikan dengan kentang goreng."
  },
  {
    id: "13",
    name: "Chicken Cordon Bleu",
    price: "Rp53.000",
    image: chickenKatsu,
    category: "Main Course",
    description: "Ayam gulung isi keju dan daging asap."
  },
  {
    id: "14",
    name: "Chicken Steak Cheesy",
    price: "Rp53.000",
    image: chickenKatsu,
    category: "Main Course"
  },

  // Menu Mie
  {
    id: "15",
    name: "Bakso Ikan Kuah",
    price: "Rp24.000",
    image: bakso,
    category: "Menu Mie"
  },
  {
    id: "16",
    name: "Bakso Halus Mie/Bihun",
    price: "Rp24.000",
    image: bakso,
    category: "Menu Mie"
  },
  {
    id: "17",
    name: "Pangsit Rebus",
    price: "Rp24.000",
    image: bakso,
    category: "Menu Mie"
  },
  {
    id: "18",
    name: "Mie Kuah Ayam",
    price: "Rp43.000",
    image: mieAyam,
    category: "Menu Mie"
  },
  {
    id: "19",
    name: "Mie Ayam Solaria Special (Pedas)",
    price: "Rp29.000",
    image: mieAyam,
    category: "Menu Mie",
    description: "Mie ayam dengan bumbu spesial pedas khas Solaria."
  },
  {
    id: "20",
    name: "Mie Ayam Pangsit Rebus",
    price: "Rp35.000",
    image: mieAyam,
    category: "Menu Mie"
  },
  {
    id: "21",
    name: "Mie Ayam Pangsit Bakso",
    price: "Rp43.000",
    image: mieAyam,
    category: "Menu Mie"
  },
  {
    id: "22",
    name: "Mie Ayam Bakso",
    price: "Rp37.000",
    image: mieAyam,
    category: "Menu Mie"
  },
  {
    id: "23",
    name: "Mie Goreng Ayam",
    price: "Rp43.000",
    image: mieAyam,
    category: "Menu Mie"
  },
  {
    id: "24",
    name: "Mie Goreng Sapi",
    price: "Rp48.000",
    image: mieAyam,
    category: "Menu Mie"
  },
  {
    id: "25",
    name: "Mie Goreng Seafood",
    price: "Rp50.000",
    image: mieAyam,
    category: "Menu Mie"
  },
  {
    id: "26",
    name: "I Fu Mie / Lo Mie",
    price: "Rp44.000",
    image: mieAyam,
    category: "Menu Mie"
  },

  // Menu Kwetiau
  {
    id: "27",
    name: "Kwetiau Ayam",
    price: "Rp31.000",
    image: kwetiau,
    category: "Menu Kwetiau"
  },
  {
    id: "28",
    name: "Kwetiau Ayam Pangsit Rebus",
    price: "Rp37.000",
    image: kwetiau,
    category: "Menu Kwetiau"
  },
  {
    id: "29",
    name: "Kwetiau Ayam Pangsit Rebus Bakso",
    price: "Rp46.000",
    image: kwetiau,
    category: "Menu Kwetiau"
  },
  {
    id: "30",
    name: "Kwetiau Ayam Bakso",
    price: "Rp39.000",
    image: kwetiau,
    category: "Menu Kwetiau"
  },
  {
    id: "31",
    name: "Kwetiau Goreng Ayam",
    price: "Rp46.000",
    image: kwetiau,
    category: "Menu Kwetiau"
  },
  {
    id: "32",
    name: "Kwetiau Masak Ayam",
    price: "Rp45.000",
    image: kwetiau,
    category: "Menu Kwetiau"
  },
  {
    id: "33",
    name: "Kwetiau Sapi Siram / Goreng",
    price: "Rp50.000",
    image: kwetiau,
    category: "Menu Kwetiau"
  },
  {
    id: "34",
    name: "Kwetiau Seafood Siram / Goreng",
    price: "Rp52.000",
    image: kwetiau,
    category: "Menu Kwetiau"
  },

  // Snack & Sampingan
  {
    id: "35",
    name: "Spring Roll",
    price: "Rp21.000",
    image: springRolls,
    category: "Snack & Sampingan"
  },
  {
    id: "36",
    name: "Prawn Ball Satay",
    price: "Rp21.000",
    image: bakso,
    category: "Snack & Sampingan"
  },
  {
    id: "37",
    name: "Fish Ball Satay",
    price: "Rp21.000",
    image: bakso,
    category: "Snack & Sampingan"
  },
  {
    id: "38",
    name: "Cuttlefish Ball Satay",
    price: "Rp21.000",
    image: bakso,
    category: "Snack & Sampingan"
  },
  {
    id: "39",
    name: "Fish Cake",
    price: "Rp21.000",
    image: bakso,
    category: "Snack & Sampingan"
  },
  {
    id: "40",
    name: "Crispy Mini Wonton",
    price: "Rp21.000",
    image: springRolls,
    category: "Snack & Sampingan"
  },
  {
    id: "41",
    name: "French Fries",
    price: "Rp21.000",
    image: frenchFries,
    category: "Snack & Sampingan"
  },
  {
    id: "42",
    name: "Wedges with Bolognese Sauce",
    price: "Rp25.000",
    image: frenchFries,
    category: "Snack & Sampingan"
  },
  {
    id: "43",
    name: "Siomay",
    price: "Rp12.000",
    image: bakso,
    category: "Snack & Sampingan"
  },

  // Express Bowl
  {
    id: "44",
    name: "Express Bowl Ayam (Rica / Mentega)",
    price: "Rp26.000",
    image: chickenTeriyaki,
    category: "Express Bowl"
  },
  {
    id: "45",
    name: "Express Bowl Fillet Ikan / Mix",
    price: "Rp29.000 - Rp32.000",
    image: chickenKatsu,
    category: "Express Bowl"
  }
];
